export { default } from './Input';



// WEBPACK FOOTER //
// ./src/design-system/atoms/Input/index.jsx